/* @flow */

import WebshopHeaderSettings from './WebshopHeaderSettings'
import WebshopHeader from './WebshopHeader'
import { WEBSHOP_DESIGN_PAGE_MODULE_HEADER } from '../../shared'

type HeaderWidgetSettings = {
  type: 'classic' | 'modern',

  logo_position: 'center' | 'left',
  logo_size_mode: 'set_width' | 'set_height',
  logo_height: number,
  logo_width: number,
  backdrop_logo_override: ?File,

  navigation_font: string | null,
  navigation_font_color: string,
  navigation_font_size: number,
  navigation_font_hover_color: string,
  navigation_hover_underline: boolean,
  navigation_uppercase: boolean,
  backdrop_navigation_font_color: string,
  backdrop_navigation_font_hover_color: string,

  navigation_space_between_each: number,
  space_between_logo_and_navigation: number,
}

const widget = {
  component: WebshopHeader,
  settings: WebshopHeaderSettings,

  available_children: [],
  available_only_in_modules: [WEBSHOP_DESIGN_PAGE_MODULE_HEADER],
  label: 'Header',

  map_settings: values => {
    const copy = { ...values, data: { ...values.data } }

    // If we do not upload any files we should map the value to null instead of empty files array
    if (
      Array.isArray(copy.data.backdrop_logo_override) &&
      copy.data.backdrop_logo_override.length === 0
    ) {
      copy.data.backdrop_logo_override = null
    }

    if (copy.data.logo_height !== null) {
      copy.data.logo_height = parseInt(copy.data.logo_height, 10)

      if (isNaN(copy.data.logo_height)) {
        copy.data.logo_height = null
      }
    }

    if (copy.data.logo_width !== null) {
      copy.data.logo_width = parseInt(copy.data.logo_width, 10)

      if (isNaN(copy.data.logo_width)) {
        copy.data.logo_width = null
      }
    }

    return copy
  },

  default_settings: ({
    type: 'modern',

    logo_position: 'center',
    logo_size_mode: 'set_height',
    logo_height: 25,
    logo_width: 100,
    backdrop_logo_override: null,

    navigation_font: null,
    navigation_font_size: 13,
    navigation_font_color: '#000000',
    navigation_font_hover_color: '#000000',
    navigation_hover_underline: false,
    navigation_uppercase: true,
    backdrop_navigation_font_color: '#000000',
    backdrop_navigation_font_hover_color: '#000000',

    navigation_space_between_each: 15,
    space_between_logo_and_navigation: 30,
  }: HeaderWidgetSettings),

  default_style: {
    paddingLeft: 20,
    paddingRight: 20,
    paddingTop: 20,
    paddingBottom: 20,

    marginLeft: 0,
    marginRight: 0,
    marginTop: 0,
    marginBottom: 0,
  },
}

export default widget
